import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { SpaceRenovationRequestsState } from './types';

const initialState: SpaceRenovationRequestsState = {
  searchTerm: '',
};

const spaceRenovationRequestsSlice = createSlice({
  name: 'cooperativeSpaceRenovationRequests',
  initialState,
  reducers: {
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    },
  },
});

export default spaceRenovationRequestsSlice.reducer;
export const { setSearchTerm } = spaceRenovationRequestsSlice.actions;
